import "./App.css"
import Header from "./components/common/header/Header"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import About from "./components/about/About"
import AboutUs from "./components/about/aboutUs"
import CourseHome from "./components/allcourses/CourseHome"
import Team from "./components/team/Team"
import Pricing from "./components/pricing/Pricing"
import Blog from "./components/blog/Blog"
import Contact from "./components/contact/Contact"
import Footer from "./components/common/footer/Footer"
import Home from "./components/home/Home"
import Dashboard  from "./components/Dashboard"
import ScrollToTopButton from './components/common/ScrollToTopButton/ScrollToTopButton';
function App() {
  return (
    <>
      <Router>
        <Header />
        <main className="main-content">
          <Switch>
            <Route exact path='/' component={Home} />
            <Route exact path='/dashboard' component={Dashboard} />
            <Route exact path='/about' component={About} />
            <Route exact path='/about-us' component={AboutUs} />
            <Route exact path='/courses' component={CourseHome} />
            <Route exact path='/team' component={Team} />
            <Route exact path='/pricing' component={Pricing} />
            <Route exact path='/journal' component={Blog} />
            <Route exact path='/contact' component={Contact} />
          </Switch>
          <Footer />
        </main>
      </Router>
      <ScrollToTopButton />
    </>
  )
}

export default App
